export const Bio = {
  name: "Sakshi Pathak",
  roles: [
    "Frontend Developer",
    "Web Designer",
    "Programmer",
  ],
  description:
  "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
github: "https://github.com/1sakshipathak",
resume:
  "https://drive.google.com/file/d/1Ws3LfTJXmZOx-rBevYyNLxzOcKpOp58f/view",
linkedin: "https://www.linkedin.com/feed/",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      
    ],
  },
  {
    title: "Backend",
    skills: [
     
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
     
    ],
  },
];

export const experiences = [
  
  
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/b/b5/Galgotias_College_logo.jpg",
    school: "Galgotias College of Engineering and Technology,Greater Noida",
    date: "Oct 2022 - July 2024",
    grade: "7.56 CGPA",
    desc: "I am currently pursuing a Masters of computer Application at Galgotias College of Engineering and Technology,Greater Noida. I have completed 3 semesters and have a CGPA of 7.56. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of Code-on Club at GCET, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Masters of Computer Application",
  },
  {
    id: 1,
    img: "https://images.collegedunia.com/public/college_data/images/logos/1395663282D.S.%20College.png",
    school: "D.S.College Aligarh",
    date: "Aug 2019 - June 2022",
    grade: "69.5%",
    desc: "I completed my Graduation at D.S.College Aligarh, where I studied Science with Math.",
    degree: "B.Sc., Science with Math",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRi9W0bSz84DrUPclbEGXu-IV1OD_jckcFCp6X4zVUBc3x24_aWoTfQXTJ90fDL69NNxg&usqp=CAU",
    school: "D.D.J.S BALIKA I College,Kasganj",
    date: "Apr 2017 - Apr 2018",
    grade: "73%",
    desc: "I completed my class 12 high school education at D.D.J.S BALIKA I College,Kasganj, where I studied Science with Math.",
    degree: "XII, Science with Math",
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRi9W0bSz84DrUPclbEGXu-IV1OD_jckcFCp6X4zVUBc3x24_aWoTfQXTJ90fDL69NNxg&usqp=CAU",
    school: "D.D.J.S BALIKA I College,Kasganj",
    date: "Apr 2015 - Apr 2016",
    grade: "85.5%",
    desc: "I completed my class 10 education at D.D.J.S BALIKA I College,Kasganj, where I studied Science with Math.",
    degree: "X, Science with Math",
  },
];

export const projects = [
  {
    id: 9,
    title: "My site",
    date: "Jun 2023 - June 2023",
    description:
      "I created my portfolio so you could learn more about my background and my proficiency with technology. This website was made by myself using HTML5, CSS, and ReactJS. This has an additional section added for convenient communication and teamwork.",
    image:
      "https://user-images.githubusercontent.com/64485885/255202416-e1f89b04-2788-45b0-abc2-9dec616669e2.png",
    tags: [
      "HTML",
      "CSS"
    ],
    category: "web application",
    github: "https://github.com/1sakshipathak/My-site",
    webapp: "https://1sakshipathak.github.io/My-site/ ",
    
  },
  {
    id: 0,
    title: "SV shop",
    date: "Aug 2023- Sep 2023",
    description:
      "Developed a web application website that allows users to browse and purchase various products online.This website is built using the foundational technologies of HTML, CSS, and JavaScript to create a user-friendly online shopping experience. It provides a solid foundation for a functional online store and allows for customization using these core web development technologies.",
    image:
      "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
    tags: ["HTML", "CSS", "Java Script"],
    category: "web application",
    github: "https://github.com/1sakshipathak/ECommerce-Website",
    webapp: "https://1sakshipathak.github.io/ECommerce-Website/ ",
    
  },
  {
    id: 2,
    title: "Drum kit",
    date: "Jan 2023",
    description:
      "This project is a web-based drum kit built with HTML, CSS, and JavaScript. It allows you to play drum sounds using your keyboard keys! Hit a specific key, and hear the corresponding drum sound - in this case, the letter key assigned to the sound.",
    image:
      "https://github.com/rishavchanda/Brain-Tumor-Detection/raw/main/Readme_resource/Image2.png",
    tags: ["HTML", "CSS", "JS"],
    category: "Web application",
    github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    webapp: "https://1sakshipathak.github.io/Drum-kit/ ",

  },
  {
    id: 3,
    title: "Portfolio",
    date: "May 2024-May 2024",
    description:
      "I created my portfolio so you could learn more about my background and my proficiency with technology. This website was made by myself using HTML5, CSS, and ReactJS. This has an additional section added for convenient communication and teamwork..",
    image:
      "https://camo.githubusercontent.com/fbf405040ae86b5d4a40f24e4ac034982cb8c0e2d850560ba64527997b258be8/68747470733a2f2f666972656261736573746f726167652e676f6f676c65617069732e636f6d2f76302f622f6c6f67696e2d65613565322e61707073706f742e636f6d2f6f2f4255434b4f49442532302831292e706e673f616c743d6d6564696126746f6b656e3d32653735376235372d323964372d346263612d613562322d653164346538313432373435",
    tags: ["React.js", "Tailwind"],
    category: "Web app",
    github: "https://github.com/rishavchanda/Buckoid-Android-App",
  },
  {
    id: 10,
    title: "Mintra Clone",
    date: "Apr 2024 - Apr 2024",
    description:
      "This project, MyntraClone, is a fully functional e-commerce website inspired by the popular online fashion store Myntra. Built using modern web technologies, it offers a seamless shopping experience replicating core functionalities",
    image:
      "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    tags: ["Reactjs", "Tailwind"],
    category: "web app",
    github: "",
    webapp: "",
  },
  {
    id: 8,
    title: "Simon game",
    date: "May 2023",
    description:
      "This web-based Simon Says game, built with HTML, CSS, and JavaScript, takes the classic memory test to a whole new level. Get ready for a thrilling challenge as the next step depends on your ability to recall and replicate the entire sequence perfectly!.",
    image:
      "https://camo.githubusercontent.com/a8b3e1ebf26d4c95f75bc6671189a3590eb67eb8332d7c7452492990e731efb9/68747470733a2f2f77617265686f7573652d63616d6f2e696e67726573732e636d68312e707366686f737465642e6f72672f356137383335396561323762643261633232336437656662306639303831306437373930383436312f363837343734373037333361326632663633366336663735363432653637363937343638373536323735373336353732363336663665373436353665373432653633366636643266363137333733363537343733326633383339333633363339333232663332333433343333333033333339333832663333333636363330363533333636333032643331333336333632326433313331363533373264333833323335333832643334363433303633333936333635333136353334333133393265363736393636",
    tags: ["HTML", "CSS", "JS"],
    category: "Web Application ",
    github: "",
    webapp: "",

  },
];

export const TimeLineData = [
  
];
